import ReturnOrderItemService from '../../services/ReturnOrderItemService';
import returnOrderItemUseCase from './returnOrderItemUseCase';

const returnOrderItemFactory = returnOrderItemUseCase({
  ReturnOrderItemService: ReturnOrderItemService(),
});

export default returnOrderItemFactory;
